<template>
    <div id="frame-facture" class="container-frame">
        <h1 id="frame-title">Facture</h1>
        <div id="container-facture">
            <!--COLONE 1-->
            <div class="general-sous-menu" id="general-enregistrement">
                <h3>Type de facture</h3>
                <div class="general-group">
                    <input type="radio" name="typeDeFacture" />
                    <label>Sécurisée</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="typeDeFacture" />
                    <label>Dégradée</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="typeDeFacture" />
                    <label>Pour le TLA</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="typeDeFacture" />
                    <label>Sans Vitale</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Signature</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Autoriser désynchro</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="signature" />
                    <label>Signée</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="signature" />
                    <label>Non Signée</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="signature" />
                    <label>Désynchronisé</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Lieu d'éxécution</h3>
                <div class="general-group">
                    <input type="radio" name="lieuExécution" />
                    <label>Lieu d'exercice</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="signature" />
                    <label>Déplacement</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Tarifs Outre-mer</h3>
                <div class="general-group">
                    <input type="checkbox" v-model="appliqueTarifOutreMer" />
                    <label>Appliquer Tarifs OM</label>
                </div>
                <div class="general-group">
                    <select name="outreMer">
                        <option value="Antilles">Antilles</option>
                        <option value="Antilles">Guyane</option>
                        <option value="Mayotte">Guyane</option>
                    </select>
                </div>
            </div>
            <!--COLONE 2-->
            <div class="general-sous-menu">
                <h3>Impression assuré(e)</h3>
                <div class="general-group">
                    <input type="radio" name="formatImpression" />
                    <label>Portrait</label>
                    <input type="radio" name="formatImpression" />
                    <label>Paysage</label>
                </div>
                <div class="general-group">
                    <label>Marge Haut</label>
                    <input type="number" />
                    <label>mm</label>
                </div>
                <div class="general-group">
                    <label>Marge Gauche</label>
                    <input type="number" />
                    <label>mm</label>
                </div>
                <div class="general-group">
                    <label>Police</label>
                    <select name="police">
                        <option value="Arial">Arial</option>
                        <option value="Courrier New">Courrier New</option>
                        <option value="S Sans Serif">MS Sans Serif</option>
                        <option value="System">System</option>

                    </select>
                </div>
                <div class="general-group">
                    <label>Police</label>
                    <select name="typePoliceImpressionAssure">
                        <option value="Arial">Arial</option>
                        <option value="Courier new">Courier new</option>
                        <option value="MS Sans Serif">MS Sans Serif</option>
                        <option value="System"></option>
                    </select>
                </div>
                <div class="general-group">
                    <label>Taille</label>
                    <select name="taillePoliceImpressionAssure">
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                    </select>
                    <input type="checkbox" />
                    <label>Gras</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Défauts facture</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Actes en série</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Carnet médical présenté</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Régime Alsace-Moselle</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Concerne l'ALD'</label>
                </div>
                <div class="general-group">
                    <label>Acte par défaut</label>
                    <input type="text" />
                </div>
            </div>
            <!--COLONE 3-->
            <div class="general-sous-menu">
                <h3>Impession actes</h3>
                <div class="general-group">
                    <input type="radio" name="formatImpressionActe" />
                    <label>Portrait</label>
                    <input type="radio" name="formatImpressionActe" />
                    <label>Paysage</label>
                </div>
                <div class="general-group">
                    <label>Police</label>
                    <select name="nomPoliceActe">
                        <option value="Arial">Arial</option>
                        <option value="Courrier New">Courrier New</option>
                        <option value="S Sans Serif">MS Sans Serif</option>
                        <option value="System">System</option>
                    </select>
                </div>
                <div class="general-group">
                    <label>Marge Haut</label>
                    <input type="number" />
                    <label>mm</label>
                </div>
                <div class="general-group">
                    <label>Marge Gauche</label>
                    <input type="number" />
                    <label>mm</label>
                </div>
                <div class="general-group">
                    <label>Police</label>
                    <select name="typePolice">
                        <option value="Arial">Arial</option>
                        <option value="Courier new">Courier new</option>
                        <option value="MS Sans Serif">MS Sans Serif</option>
                        <option value="System"></option>
                    </select>
                </div>
                <div class="general-group">
                    <label>Taille</label>
                    <select name="taiilePolice">
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                    </select>
                    <input type="checkbox" />
                    <label>Gras</label>
                </div>
                <div class="general-group">
                    <input type="checkbox"/>
                    <label>Message pour page suivante</label>
                </div>
            </div>
            <div class="general-sous-menu">
                <h3>Mode de paiement par défaut</h3>
                <div class="general-group">
                    <select>
                        <option>Espèces</option>
                        <option value="Chèque reçu">Chèque reçu</option>
                        <option value="Pas de règlement effectif">Pas de règlement effectif</option>
                        <option value="Carte bancaire">Carte bancaire</option>
                        <option value="Virement">Virement</option>
                    </select>
                    <div class="general-group">
                        <label>Dépassement avant alerte:</label>
                        <input type="number" value="250"/>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Bouton de saisie des actes</h3>
                    <div class="general-group">
                        <input type="button"  value="01"/>
                        <label> =></label>
                        <select>
                            <option value="Recopie d'actes">Recopie d'actes</option>
                            <option value="Actes personnels">Actes personnels</option>
                            <option value="Saisie détaillée">Saisie détaillée</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div id="frame-footer">
            <button @click="OK()">OK</button>
            <button @click="annuler()">Annuler</button>
            <button @click="appliquer()">Appliquer</button>
        </div>
    </div>
</template>
<style scope>
    @import 'parametre.css';
</style>
<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Parametre Facture',
                appliqueTarifOutreMer: false,
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>
